<div fxLayout="row" fxLayoutAlign="center">
    <form [formGroup]="form" fxLayout="column" class="container" fxFlex="88">
        <div class="txt-h-30-7 mb-60 mt-48" fxLayoutAlign="center">{{'Ask for support or information'|i18n}}</div>
        <div class="txt-p-18-4 mb-16">{{'Describe your problem or requirement and enter community details'|i18n}}</div>
        <div class="panel" fxLayout="column" fxLayoutGap="16px">
            <div fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start center"
                 fxLayout.lt-md="column" fxLayoutAlign.lt-md="center center">
                <div fxFlex.gt-sm="5">
                    <div fxLayoutAlign="center center" class="circle">1</div>
                </div>
                <div fxFlex.gt-sm="1"></div>
                <div class="txt-h-20-7" fxLayoutAlign.lt-md="center center"
                     [ngClass.lt-md]="'t-center mt-10 mb-10'">{{'What kind of request would you like to submit?'|i18n}}</div>
            </div>
            <div fxLayout="row" class="mt-8 mb-20 radio-options">
                <div *ngIf="!mobile" fxFlex="6"></div>
                <div fxLayout="column" class="inner-panel" fxFlex.gt-sm>
                    <mat-radio-group newline formControlName="requestType" color="primary"
                                     fxLayout="column" fxLayoutGap.gt-sm="35px" fxLayoutGap.lt-md="30px"
                                     class="radio-font-size">
                        <mat-radio-button app-radio-button class="radio-option-padding"
                                          *ngFor="let requestType of requestTypes | keyvalue:sortRequests"
                                          [value]="requestType.value">
                            {{requestType.value|i18n}}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
                <div *ngIf="!mobile" fxFlex="5"></div>
            </div>
            <div class="mt-8" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start center"
                 fxLayout.lt-md="column" fxLayoutAlign.lt-md="center center" [ngClass.lt-md]="'mt-10'">
                <div fxFlex.gt-sm="5">
                    <div fxLayoutAlign="center center" class="circle">2</div>
                </div>
                <div *ngIf="!mobile" fxFlex="1"></div>
                <div class="txt-h-20-7" fxLayoutAlign.lt-md="center center"
                     [ngClass.lt-md]="'t-center mt-10 mb-10'">{{'Enter community data'|i18n}}</div>
            </div>
            <div class="mt-8" fxLayout="row">
                <div *ngIf="!mobile" fxFlex="6"></div>
                <div fxLayout="column" class="inner-panel" fxFlex fxLayoutGap.gt-sm="10px" fxLayoutGap.lt-md="0px">
                    <div fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start center" fxLayoutGap.gt-sm="0px"
                         fxLayout.lt-md="column" fxLayoutAlign.lt-md="start start" fxLayoutGap.lt-md="10px"
                         class="txt-p-16-4">
                        <div fxFlex.gt-sm="25">{{'Community name'|i18n}}:*</div>
                        <mat-select app-small-select formControlName="communityId"
                                    placeholder="{{'Community name'|i18n}}" fxFlex.gt-sm="30">
                            <mat-option *ngFor="let community of communities" [value]="community">
                                <em>{{community.path|nicePath}}</em>
                            </mat-option>
                        </mat-select>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <div *ngIf="!mobile" fxFlex="25"></div>
                        <div fxFlex.gt-sm="30"
                             [style.visibility]="form.controls.communityId.invalid && form.controls.communityId.touched ? 'visible' : 'hidden'"
                             class="txt-a-16-7 mt-10">
                            {{'Select a community'|i18n}}
                        </div>
                    </div>
                    <div app-input-container class="mt-10 txt-p-16-4"
                         fxLayout="row" fxLayoutAlign="start center" fxLayoutGap.gt-sm="0px"
                         fxLayout.lt-md="column" fxLayoutAlign.lt-md="start start" fxLayoutGap.lt-md="10px">
                        <div fxFlex.gt-sm="25">{{'Name'|i18n}}:*</div>
                        <input fxFlex.gt-sm="30" app-input disabled formControlName='firstName'>
                        <div *ngIf="mobile"
                             [style.visibility]="form.controls.firstName.invalid && form.controls.firstName.touched ? 'visible' : 'hidden'"
                             class="txt-a-16-7">
                            {{'Enter first name'|i18n}}
                        </div>
                        <div *ngIf="!mobile" fxFlex="5"></div>
                        <div fxFlex.gt-sm="20">{{'Last name'|i18n}}:*</div>
                        <input fxFlex.gt-sm="20" app-input disabled formControlName='lastName'>
                        <div *ngIf="mobile"
                             [style.visibility]="form.controls.lastName.invalid && form.controls.lastName.touched ? 'visible' : 'hidden'"
                             class="txt-a-16-7">
                            {{'Enter last name'|i18n}}
                        </div>
                    </div>
                    <div *ngIf="!mobile" fxLayout="row" fxLayoutAlign="start center">
                        <div fxFlex="25"></div>
                        <div fxFlex="30"
                             [style.visibility]="form.controls.firstName.invalid && form.controls.firstName.touched ? 'visible' : 'hidden'"
                             class="txt-a-16-7">
                            {{'Enter first name'|i18n}}
                        </div>
                        <div fxFlex="25"></div>
                        <div fxFlex="20"
                             [style.visibility]="form.controls.lastName.invalid && form.controls.lastName.touched ? 'visible' : 'hidden'"
                             class="txt-a-16-7">
                            {{'Enter last name'|i18n}}
                        </div>
                    </div>
                    <div app-input-container class="mt-10 txt-p-16-4"
                         fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start center" fxLayoutGap.gt-sm="0px"
                         fxLayout.lt-md="column" fxLayoutAlign.lt-md="start start" fxLayoutGap.lt-md="10px">
                        <div fxFlex.gt-sm="25">{{'Email for contact back'|i18n}}:*</div>
                        <input fxFlex.gt-sm="30" app-input disabled formControlName='email'>
                        <div *ngIf="mobile"
                             [style.visibility]="form.controls.email.invalid && form.controls.email.touched ? 'visible' : 'hidden'"
                             class="txt-a-16-7">
                            {{'Enter email'|i18n}}
                        </div>
                        <div *ngIf="!mobile" fxFlex="5"></div>
                        <div fxFlex.gt-sm="20">{{'Mobile number'|i18n}}:*</div>
                        <input fxFlex.gt-sm="20" app-input disabled formControlName='mobile'>
                        <div *ngIf="mobile"
                             [style.visibility]="form.controls.mobile.invalid && form.controls.mobile.touched ? 'visible' : 'hidden'"
                             class="txt-a-16-7">
                            {{'Invalid mobile number'|i18n}}
                        </div>
                    </div>
                    <div *ngIf="!mobile" fxLayout="row" fxLayoutAlign="start center">
                        <div fxFlex="25"></div>
                        <div fxFlex="30"
                             [style.visibility]="form.controls.email.invalid && form.controls.email.touched ? 'visible' : 'hidden'"
                             class="txt-a-16-7">
                            {{'Enter email'|i18n}}
                        </div>
                        <div fxFlex="25"></div>
                        <div fxFlex="20"
                             [style.visibility]="form.controls.mobile.invalid && form.controls.mobile.touched ? 'visible' : 'hidden'"
                             class="txt-a-16-7">
                            {{'Invalid mobile number'|i18n}}
                        </div>
                    </div>
                    <div class="mt-10 txt-p-16-4"
                         fxLayout.gt-sm="row" fxLayoutGap.gt-sm="0"
                         fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
                        <div fxFlex.gt-sm="25" class="mt-10">{{'Problem description'|i18n}}:*</div>
                        <textarea matInput
                                  placeholder="{{'Add description here.'|i18n}}"
                                  formControlName='description'
                                  cdkTextareaAutosize
                                  cdkAutosizeMinRows="3"
                                  cdkAutosizeMaxRows="20"
                                  class="description"></textarea>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <div *ngIf="!mobile" fxFlex="25"></div>
                        <div fxFlex.gt-sm
                             [style.visibility]="form.controls.description.invalid && form.controls.description.touched ? 'visible' : 'hidden'"
                             class="txt-a-16-7" [ngClass.lt-md]="'mt-10'">
                            {{'Enter problem description'|i18n}}
                        </div>
                    </div>
                </div>
                <div *ngIf="!mobile" fxFlex="5"></div>
            </div>
            <div fxLayout="row" class="mt-20 ml-10 txt-p-16-4">
                <div *ngIf="!mobile" fxFlex="6"></div>
                <div>{{'The acquisition of this data was agreed to in the contract and is for the sole purpose of customer support.'|i18n}}</div>
            </div>
        </div>
        <div fxLayoutAlign="end" class="mt-30">
            <button app-primary-button [disabled]="!form.valid || sendingRequest" (click)="onSubmit()">
                <div *ngIf="!sendingRequest">{{'Send request'|i18n}}</div>
                <mat-spinner *ngIf="sendingRequest" app-spinner diameter="20"></mat-spinner>
            </button>
        </div>
        <div fxLayoutAlign="end"
             class="mt-20 txt-s-18-4">{{'You will be contacted by an operator as soon as possible.'|i18n}}</div>
    </form>
</div>
